<template>
  <div class="view-req-detail" dir="rtl">
    <div class="">
      <div
        ref="form"
      >
        <div >
          <ul class="relative">
            <!--            *****************************-->
            <li class="pa-1">

            <span>
                {{request_info.RequestName}}
              </span>
            </li>
            <li  class="pa-1">

            <span>
                {{request_info.LastStatus}}
              </span>
            </li>
            <!--            *****************************-->
            <li  class="pa-1">
              <label>
                کارشناس بازدید
:
              </label>

              <span>
                {{request_info.ExpertName}}
              </span>
            </li>
            <li class="pa-1">
              <label>
                رمز دستگاه
                :
              </label>
              <span>
                {{request_info.DevicePass}}
              </span>
            </li>
            <li class="pa-1">
              <label>
                ایرادات ظاهری
                :
              </label>
              <span>
                {{request_info.AppearanceProblem}}
              </span>
            </li>

            <li>
              <label>
                شماره تماس
                :
              </label>

              <span>
                {{request_info.CustomerMobile}}
              </span>
            </li>

            <li>
              <label>
                نظر کارشناس بازدید
                :
              </label>

              <span>
                {{request_info.ExpertOpinion}}
              </span>
            </li>
            <li>
              <label>
                لوازم همراه
                :
              </label>
              <div class="text-center">
                <v-chip v-for="item in request_info.PredefinedGlobal"
                        class="ma-1"
                        color="primary"
                >
                  {{item.Text}}:{{item.Value}}
                </v-chip>

                <v-chip
                  v-for="item in request_info.PredefinedChecked"
                  class="ma-1"
                  color="primary"
                >
                  {{item.Text}}:{{item.Value}}

                </v-chip>
              </div>
            </li>
            <li>
              <label>
                توضیحات ارجاع
                :
              </label>

              <span>
               {{request_info.LastTechStatus}}
              </span>
            </li>
            <li>
              <label>
                حدود قیمت
                :
              </label>

              <span>
               {{request_info.TechPriceRange}}
              </span>
            </li>

            <li>
              <label>
                اخرین وضعیت
                :
              </label>

              <span>
               {{request_info.LastTechStatus}}
              </span>
            </li>

          </ul>

          <v-row>

            <v-col cols="12" class="pa-1">
              <label>
                آدرس ها
                :
              </label>
              <div v-for="item in request_info.Addresses">
                <div class="addresses">
                  <span>
                    {{request_info.LastTechStatus}}
                  </span>
                </div>


              </div>

            </v-col>

          </v-row>
          <!--            *****************************-->


        </div>

      </div>

    </div>
  </div>
</template>
<script>
  import {bus} from '../../main.js'

  export default {
    props: [
      'passing_data'
    ],
    data() {
      return {
        errors: [],
        request_info: [],
        action_button_text: "",
        request_statuses: [],
        next_action_status: 0,
        technician_name: "hamid mokhtari",
        device_password: "hamid mokhtari",
        rules: {
          required: value => !!value || 'الزامی',
          fullName: value => value.length <= 30 || 'ماکسیمم 30 کاراکتر می باشد.',
          PersianFullName: value => {
            const pattern = /^[پچجحخهعغآ؟.،آفقثصضشسیبلاتنمکگوئدذرزطظژ!!ؤإأءًٌٍَُِّ\s]+$/
            return pattern.test(value) || 'نام و نام خانوادگی فارسی نیست.'
          },
          mobile: value => {
            const pattern = /^(\+98|0098|98|0)?9\d{9}$/
            return pattern.test(value) || 'فرمت موبایل صحیح نیست.'
          },
        },
      }
    }, watch: {
      "selected_province": function () {
        this.get_cities()
      }
    }, mounted() {
      // var passing_data = JSON.parse(localStorage.getItem('request_data'));
      // this.enable_send_from_country = passing_data.on_site_service;
      // this.get_phone_prefix()
      // this.get_device_status()
      // this.get_provinces()
      this.get_request_info();
    },
    methods: {
      get_request_info() {
        var self = this;
        var user_id = JSON.parse(localStorage.getItem("profile")).UserId
        const send_data = {
          "ExpertId": user_id,
          "RequestId": this.$route.params.rec_id,
        };
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetRequestInfoByReqId', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
             this.request_info = response.data.rec;
              this.get_device_status();
            }
            // this.$router.push({ path: "/post-login", params: {} });

          }).catch(e => {
          this.errors.push(e);

        })

      },


    }
  }
</script>
